import Vue from 'vue'

// axios
import axios from 'axios'

const baseURL = process.env.VUE_APP_BASE_URL

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

axiosIns.interceptors.request.use(
  config => {
    const companyUen = process.env.VUE_APP_COMPANY_UEN
    if (companyUen) {
      config.headers['X-Company-UEN'] = companyUen
    }
    return config
  },
  error => Promise.reject(error)
)

Vue.prototype.$http = axiosIns

export default axiosIns
